import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "vue"
import type {
  CommonPaymentRequest,
  PaymentRequestStatus,
} from "./paymentRequest"

export type RetrievePaymentRequestResponse =
  CommonPaymentRequest

export type ListPaymentRequestsFilter = {
  search?: string
  customerId?: string
  status?: PaymentRequestStatus
}

export type ListPaymentRequestsOrdering =
  | "createdAt"
  | "-createdAt"

export type ListPaymentRequestsQuery =
  ListPaymentRequestsFilter & {
    ordering?: ListPaymentRequestsOrdering
  } & Pagination

const retrievePaymentRequest = async (
  paymentRequestId?: CommonPaymentRequest["ident"]
): Promise<RetrievePaymentRequestResponse> => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<RetrievePaymentRequestResponse>
  >(`/services/payments/${paymentRequestId}/`)

  return {
    ...body,
    createdAt: DateFns.parseISO(body.createdAt),
    lastSentAt: body.lastSentAt
      ? DateFns.parseISO(body.lastSentAt)
      : null,
  }
}

export const usePaymentRequest = (
  paymentRequestId?: MaybeRef<CommonPaymentRequest["ident"]>
) =>
  useQuery({
    queryKey: [
      PAYMENT_REQUESTS_QUERY_KEY,
      paymentRequestId,
    ] as const,
    queryFn: ({ queryKey: [_, paymentRequestId_] }) =>
      retrievePaymentRequest(paymentRequestId_),
  })
